"use strict";

export function init() {
    let $ajaxForm = $('.js-ajax-form');
    $ajaxForm.on('reset.ajax-form', function() {
       $(this).find('.js-ajax-form__form').submit();
    });
}